import { Component, OnInit, effect, inject,ElementRef } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { PartnerService } from '../../service/partner.service';
import { SharedSignalsService } from 'src/app/common/services/shared-signals.service';
import { CheckoutService } from 'src/app/checkout/services/checkout.service';
import { regexConstant } from 'src/app/common/constants/regex-pattern.constant';

@Component({
    selector: 'taly-request-form',
    templateUrl: './request-form.component.html',
    styleUrls: ['./request-form.component.scss'],
    standalone: false
})
export class RequestFormComponent implements OnInit {

  regexStr = "^[a-zA-Z0-9 ]+$";

  transferSignal = inject(SharedSignalsService);
  partnerRequestForm!: FormGroup;
  displayDialog: boolean = false;
  isTermOfUse : boolean = false;
  isformSubmit : boolean = false;
  countries:any[] = [];
  businessType:any[] = [];
  annulaSales:any[]= [];
  averageOrder:any[]= [];
  platForms:any[] =[];
  categories:any[] = [];
  isNotInStore: boolean = false;
  urlRegEx = '(https?://)?([\\da-z.-]+)\\.([a-z.]{2,6})[/\\w .-]*/?';
  textDirection:string;

  get f() {
    return this.partnerRequestForm.controls;
  }

  constructor(private fb: FormBuilder, private partnerService : PartnerService,private elementRef: ElementRef,private checkoutService: CheckoutService,){

    this.partnerRequestForm = this.fb.group({
      
      businessName: ['', [Validators.required, Validators.minLength(3),  Validators.pattern(this.regexStr)]],  
      country: [null, [Validators.required]],
      category: [null, [Validators.required]],
      busines_type: [null, [Validators.required]],
      annual_sales: [null, [Validators.required]],
      average_orders: [null, [Validators.required]],
      mobileNumber: [null, [Validators.required, Validators.pattern(regexConstant.KUWAIT_MOBILE_NUMBER), Validators.maxLength(8), Validators.minLength(8)]],

      platform: [null],
      webURL: [null],
      
      emailAddress: ['', [Validators.required, Validators.email, Validators.minLength(3), Validators.maxLength(256)]],
      comments: [''],

      otherPlatfom: [''],
      otherIndustry : ['']
      
    });
    effect(() => { 
      this.textDirection = this.transferSignal.textDirection()
      
    })

  }

  isOtherPlatform : boolean = false;
  isOtherIndustry : boolean = false;

  ngOnInit(): void {
    window.scrollTo({ top: 0, behavior: 'smooth' });
    this. getCountries();
    this.getBusinessType();
    this.getAnnulaSales();
    this.getAverageOrder();
    this.getPlatform();
    this.getCategory()

    this.partnerRequestForm.get("busines_type").valueChanges.subscribe(val => {         
      this.onBusinessType(val?.nameEn)
      if(val?.nameEn=='In-Store'){
        this.partnerRequestForm.get('webURL').clearValidators();
        this.partnerRequestForm.get('platform').clearValidators();
      }
    });
    this.partnerRequestForm.get("platform").valueChanges.subscribe(val => {
      this.isOtherPlatform = false;
      if(val?.nameEn == "Other"){
        this.isOtherPlatform = true;
        this.partnerRequestForm.get('otherPlatfom').setValidators([Validators.required]);
      }else{
        this.isOtherPlatform = false;
        this.partnerRequestForm.get('otherPlatfom').clearAsyncValidators();
      }
    })

    this.partnerRequestForm.get("category").valueChanges.subscribe(val => {
      this.isOtherIndustry = false; 
      if(val?.nameEn == "Other"){
        this.isOtherIndustry = true; 
        this.partnerRequestForm.get('otherIndustry').setValidators([Validators.required]);
      }else{
        this.isOtherIndustry = false; 
        this.partnerRequestForm.get('otherIndustry').clearAsyncValidators();
      }
    })
    
  }

  getCountries(){
    this.partnerService.getCountries().subscribe( res => {
      this.countries = res?.filter((elem) => elem?.status == '1');
    }, err => {
      this.transferSignal.showMessage('error', err?.message || err)
    })
  }

  getCategory(){
    this.partnerService.getCategories().subscribe( res => {
      this.categories = res?.filter((elem) => elem?.status == '1');
      
    }, err => {
      this.transferSignal.showMessage('error', err?.message || err)
    })
  }

  getBusinessType(){
    this.partnerService.getBusinessType().subscribe( res => {
      this.businessType = res?.filter((elem) => elem?.status == '1');
    }, err => {
      this.transferSignal.showMessage('error', err?.message || err)
    })
  }

  getAnnulaSales(){
    this.partnerService.getAnnulaSales().subscribe( res => {
      this.annulaSales = res?.filter((elem) => elem?.status == '1');
    }, err => {
      this.transferSignal.showMessage('error', err?.message || err)
    })
  }

  getAverageOrder(){
    this.partnerService.getAverageOrder().subscribe( res => {
      this.averageOrder = res?.filter((elem) => elem?.status == '1');
    }, err => {
      this.transferSignal.showMessage('error', err?.message || err)
    })
  }


  getPlatform(){
    this.partnerService.getPlatform().subscribe( res => {
      this.platForms = res?.filter((elem) => elem?.status == '1');;
    }, err => {
      this.transferSignal.showMessage('error', err?.message || err)
    })
  }

  showDialog(isTerm:boolean){
    this.displayDialog = true;
    this.isTermOfUse = isTerm
  }
  
  onKeyPress(event: KeyboardEvent) {
    if (this.partnerRequestForm.get('emailAddress').valid) {
      if(this.elementRef.nativeElement.querySelector('.pi')){
        this.elementRef.nativeElement.querySelector('.pi').style.display = 'none';
      }
    } else {
      if(this.elementRef.nativeElement.querySelector('.pi')){
        this.elementRef.nativeElement.querySelector('.pi').style.display = 'block';
      }
    }
  }

  isInputNotEmpty(formCtrl: any): boolean {
    const value = this.partnerRequestForm.get(formCtrl)?.value.trim();
    if (value) {
      return true
    } else {
      return false
    }
  }

 onSubmit() {



  
  if(this.partnerRequestForm.invalid){
    return;
  }

  const requestBody = {
    status : "PENDING",
    businessName: this.partnerRequestForm.get('businessName')?.value.trim(),
    countryNameEn: this.partnerRequestForm.get('country')?.value?.nameEn?.trim(),
    countryId : this.partnerRequestForm.get('country')?.value?.isoCode,
    categoryNameEn: this.partnerRequestForm.get('category')?.value?.nameEn?.trim(),
    businessType: this.partnerRequestForm.get('busines_type')?.value?.nameEn?.trim(),
    industryId: this.partnerRequestForm.get('busines_type')?.value?.id,
    annualSaleNameEn: this.partnerRequestForm.get('annual_sales')?.value?.nameEn?.trim(),
    annualSalesId: this.partnerRequestForm.get('annual_sales')?.value?.id,
    averageOrderValueNameEn: this.partnerRequestForm.get('average_orders')?.value?.nameEn?.trim(),
    averageOrderValueId: this.partnerRequestForm.get('average_orders')?.value?.id,
    contactNumber: this.partnerRequestForm.get('mobileNumber')?.value,
    businessEmail: this.partnerRequestForm.get('emailAddress')?.value,
    platformNameEn: this.partnerRequestForm.get('platform')?.value?.nameEn?.trim(),
    platfomId: this.partnerRequestForm.get('platform')?.value?.id,
    url: this.partnerRequestForm.get('webURL')?.value,
    otherIndustry :  this.partnerRequestForm.get('otherIndustry')?.value,
    otherPlatfom : this.partnerRequestForm.get('otherPlatfom')?.value,
    comments : this.partnerRequestForm.get('comments').value
  };
  this.partnerService.merchantSign_Up(requestBody).subscribe((resp) => {

    if(resp){
      this.transferSignal.setShowSignUp(false);
      this.transferSignal.setShowThankyouPopup(true);
    }
    
  }, err => {      
    this.checkoutService.showMessage('error', err);
    this.transferSignal.setErrorPopup(true);
    this.transferSignal.setShowSignUp(false);
    this.transferSignal.setShowThankyouPopup(false);

  });
 }


 onBusinessType(businessType:any) {
   switch (businessType) {
     case 'Online':
       this.isNotInStore = true;
       this.partnerRequestForm.get('webURL').setValidators([Validators.required,Validators.pattern(this.urlRegEx)]);
       this.partnerRequestForm.get('platform').setValidators([Validators.required]);
       break;
     case 'In-Store':
       this.isNotInStore = false;
       this.partnerRequestForm.get('webURL').clearValidators();
       this.partnerRequestForm.get('platform').clearValidators();
       break;
     case 'Both':
       this.isNotInStore = true;
       this.partnerRequestForm.get('webURL').setValidators([Validators.required,Validators.pattern(this.urlRegEx)]);
       this.partnerRequestForm.get('platform').setValidators([Validators.required]);
       break;

     default:
      this.partnerRequestForm.get('webURL').clearValidators();
      this.partnerRequestForm.get('platform').clearValidators();
       break;
   }
 }

}
